<div class="input-select-option"  [ngStyle]="{'background-image': 'url(' + eventType.imageUrl + ')'}" (click)="selectEvent($event)" [class.selected]="selected">
  <button type="button" mat-raised-button (click)="selectEvent($event)">
    <span>{{eventType.title}}</span>
  </button>
</div>
